(() => {
  if (document.documentElement.dataset.localPreview === 'true') return;

  const initialize = (root = document) => {
    root.querySelectorAll('[data-gfe-shape-filter]').forEach((filter) => {
      if (filter.dataset.ready === 'true') return;
      filter.dataset.ready = 'true';
      const shapeTags = new Set(JSON.parse(filter.dataset.shapeTags));
      const links = [...filter.querySelectorAll('[data-shape-tag]')];
      const paths = new Map(links.map((link) => [link, new URL(link.href, location.href).pathname]));

      const currentQuery = () => {
        const query = new URLSearchParams(location.search);
        query.delete('page');
        const tagValues = query.getAll('filter.p.tag');
        if (tagValues.length) {
          query.delete('filter.p.tag');
          tagValues.forEach((value) => {
            const remaining = value.split(',').filter((tag) => !shapeTags.has(tag));
            if (remaining.length) query.append('filter.p.tag', remaining.join(','));
          });
        }
        return query;
      };

      const refreshLinks = () => {
        const query = currentQuery().toString();
        links.forEach((link) => {
          link.href = paths.get(link) + (query ? `?${query}` : '') + '#product-grid';
        });
      };

      refreshLinks();
      ['pointerdown', 'focusin', 'click'].forEach((eventName) => {
        filter.addEventListener(eventName, refreshLinks);
      });
      window.addEventListener('popstate', refreshLinks);

      const preserveShapeOnAvailability = (link) => {
        const destination = new URL(link.href, location.href);
        const collectionPath = new URL(filter.dataset.collectionUrl, location.href).pathname;
        if (destination.origin !== location.origin) return;
        const tagPath = destination.pathname.startsWith(`${collectionPath}/`) ? destination.pathname.slice(collectionPath.length + 1) : '';
        if (destination.pathname !== collectionPath && (!tagPath || tagPath.includes('/'))) return;
        const query = new URLSearchParams(location.search);
        query.delete('page');
        query.delete('gfe_availability');
        query.delete('filter.v.availability');
        if (link.dataset.gfeAvailabilityView === 'all') query.set('gfe_availability', 'all');
        else query.set('filter.v.availability', '1');
        if (!query.has('sort_by') && destination.searchParams.has('sort_by')) {
          query.set('sort_by', destination.searchParams.get('sort_by'));
        }
        link.href = `${location.pathname}?${query.toString()}#product-grid`;
      };

      document.querySelectorAll('[data-gfe-availability-view]').forEach(preserveShapeOnAvailability);
      ['pointerdown', 'focusin', 'click'].forEach((eventName) => {
        document.addEventListener(eventName, (event) => {
          const link = event.target.closest?.('[data-gfe-availability-view]');
          if (link) preserveShapeOnAvailability(link);
        }, true);
      });
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
